import React from "react";

export function ModalRoot() {
  return null;
}

export default ModalRoot;
